import axios from "axios";

// All requests are made to a relative "/api" path. In development this is
// forwarded to the Node/Express backend (http://localhost:3000) via the
// proxy configured in src/setupProxy.js (and the "proxy" field in
// package.json). In production, the Express server serves the React build
// itself, so relative "/api" requests resolve correctly without any
// extra configuration.
const apiClient = axios.create({
  baseURL: "/api",
  headers: {
    "Content-Type": "application/json",
  },
});

export default apiClient;
